export const ColorConf = {
    PRIMARY: "#20A8D7",
    SECONDARY: "#FF4500",
    SUCCESS: "#32CD79",
    WARNING: "#FFEF00",
    DANGER: "#E85B5B",
    LIGHT_CYAN: "#44C2F1",
    DARK_GRAY: "#262626",
    GRAY: "#444444",
    DAWN_GRAY: "#474746",
    DIM_GRAY: "#555555",
    LIGHT_GRAY: "#777777",
    LIGHTER_WHITE: "#DDDDDD",
    LIGHT_WHITE: "#EEFFFF",
    WHITE: "#FFFFFF",
};

export const FontConf = {
    TITLE: "HYBeiBingYang-W",
    SCORE: "HYDiSiKe-U",
};

/*
Units:
    size: pixel (px)
    time: second (s)
 */
export const UIConf = {
    BACKGROUND_FILL: ColorConf.LIGHT_WHITE,
    LOADING_FADE_OUT_DURATION: 0.3,
    Ball: {
        X_RATIO: 1 / 2,
        Y_RATIO: 1 / 4,
        RADIUS: 10,
        FILL: ColorConf.PRIMARY,
    },
    BallTrailing: {
        RADIUS: 5.5,
        FILL: ColorConf.SECONDARY + "BA",
    },
    Tablet: {
        WIDTH: 120,
        HEIGHT: 21,
        FILL: ColorConf.SUCCESS,
        X_RATIO: 1 / 2,
        Y_RATIO: 1,
        Y_OFFSET: -140,
    },
    ForbiddenZone: {
        FILL: ColorConf.DANGER + "87",
    },
    FPS: {
        LEFT: 12,
        BOTTOM: 24,
        FONT_SIZE: 12,
        FILL: ColorConf.LIGHT_GRAY,
    },
    Mask: {
        FILL: ColorConf.WHITE,
        OPACITY: 0.6,
        FADE_IN_DURATION: 0.8,
        FADE_TO_DURATION: 0.5,
    },
    MainMenu: {
        X_RATIO: 1 / 2,
        Brand: {
            Y_RATIO: 2 / 7,
            Y_OFFSET: -300,
            SHADOW_COLOR: ColorConf.DIM_GRAY,
            HOVER_SHADOW_COLOR: ColorConf.WARNING,
        },
        Hint1: {
            Y_RATIO: 4 / 7,
            Y_OFFSET: -12,
            FILL: ColorConf.GRAY,
            FONT_SIZE: 16,
        },
        Hint2: {
            Y_RATIO: 4 / 7,
            Y_OFFSET: 12,
            FILL: ColorConf.LIGHT_GRAY,
            FONT_SIZE: 12,
        },
    },
    OptionsMenu: {
        X_RATIO: 1 / 2,
        Title: {
            Y_RATIO: 2 / 7,
            FONT_FAMILY: FontConf.TITLE,
            FONT_SIZE: 48,
        },
        Hint1: {
            Y_RATIO: 4 / 7,
            Y_OFFSET: -12,
            FILL: ColorConf.GRAY,
            FONT_SIZE: 16,
        },
        Hint2: {
            Y_RATIO: 4 / 7,
            Y_OFFSET: 12,
            FILL: ColorConf.LIGHT_GRAY,
            FONT_SIZE: 12,
        },
    },
    Scoring: {
        FONT_FAMILY: FontConf.SCORE,
        Panel: {
            FILL: ColorConf.LIGHT_GRAY + "AA",
        },
        Integer: {
            FONT_SIZE: 40,
            FILL: ColorConf.WHITE,
        },
        Decimal: {
            FONT_SIZE: 32,
            FILL: ColorConf.LIGHTER_WHITE,
        },
        tip: {
            OPACITY: 0.9,
            FONT_SIZE: 20,
            FILL: ColorConf.WARNING,
            STROKE: ColorConf.DARK_GRAY + "33",
            SHADOW_COLOR: ColorConf.LIGHT_GRAY,
            DURATION: 0.6,
            ANIMATION: {
                FONT_SIZE1: 24,
                FONT_SIZE2: 25,
                STYLE_DURATION1: 0.3,
                STYLE_DURATION2: 0.4,
                X_DURATION: 0.45,
                Y_DURATION1: 0.12,
                Y_DURATION2: 0.28,
                Y_OFFSET1: -12,
            },
        },
    },
    Settlement: {
        X_RATIO: 1 / 2,
        Title: {
            Y_RATIO: 2 / 7,
            FONT_SIZE: 108,
            FONT_FAMILY: FontConf.TITLE,
            SCALE: 0.5,
            HIDE_SCALE: 0.3,
            SHOW_DURATION: 0.4,
            HIDE_DURATION: 0.3,
            WIN_SHADOW_COLOR: ColorConf.WARNING,
            FAIL_SHADOW_COLOR: ColorConf.DAWN_GRAY,
            WIN_BG_Y_OFFSET: 75,
            FAIL_BG_Y_OFFSET: -50,
            SHADOW_BLUR: 25,
            SHADOW_SPREAD: 15,
        },
        Hint1: {
            Y_RATIO: 9 / 14,
            Y_OFFSET: -12,
            FILL: ColorConf.GRAY,
            FONT_SIZE: 16,
            FADE_IN_DURATION: 0.8,
            FADE_IN_DELAY: 0.2,
            FADE_OUT_DURATION: 0.5,
        },
        Hint2: {
            Y_RATIO: 9 / 14,
            Y_OFFSET: 12,
            FILL: ColorConf.LIGHT_GRAY,
            FONT_SIZE: 12,
            FADE_IN_DURATION: 0.8,
            FADE_IN_DELAY: 0.4,
            FADE_OUT_DURATION: 0.5,
        },
    },
    Timing: {
        X_OFFSET: 15,
        Y_OFFSET: 15,
        FILL: ColorConf.DARK_GRAY,
        ALARM_FILL: ColorConf.LIGHT_CYAN,
        FONT_SIZE: 16,
        GAP: 4,
        IconG: {
            DIAMETER: 16,
            ANIMATION: {
                KEYFRAMES: [
                    { rotation: 35, y: 0 },
                    { rotation: -35, y: -3 },
                    { rotation: 25, y: -3 },
                    { rotation: -25, y: 0 },
                ],
                DURATION: 0.4,
                LOOP_DELAY: 0.6,
            },
        },
        Text: {
            LINE_HEIGHT: 16,
        },
    },
};
